import { render, staticRenderFns } from "./UpdateAutoMatchDetails.vue?vue&type=template&id=1f1fcde2&"
import script from "./UpdateAutoMatchDetails.vue?vue&type=script&lang=js&"
export * from "./UpdateAutoMatchDetails.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAutoMatchDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports